import { render, staticRenderFns } from "./WaypointsListVae.vue?vue&type=template&id=25f4bc7d&scoped=true"
import script from "./WaypointsListVae.vue?vue&type=script&lang=js"
export * from "./WaypointsListVae.vue?vue&type=script&lang=js"
import style0 from "./WaypointsListVae.vue?vue&type=style&index=0&id=25f4bc7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4bc7d",
  null
  
)

export default component.exports